<template>
    <div class="details text">
        <div class="column">
            <p>
                Show us some smoke at:
                <a class="link" href="mailto:contact@indigen.com">
                    contact@indigen.com
                </a>
            </p>
            <p v-if="mode === 'nice'">
                You can shout very loudly here:
                <a class="link" href="tel:04 93 55 06 01">
                    04 93 55 06 01
                </a>
            </p>
        </div>
        <div class="column">
            <p>
                Missioning a homing pigeon?
                <br />
                <strong v-if="mode === 'nice'">
                    Indigen Solutions<br />29 Rue Pastorelli<br />06000 Nice,
                    France
                </strong>
                <strong v-if="mode === 'cairo'">
                    Indigen Middle East<br />Al Matar, El Nozha,<br />Cairo
                    Governorate 11361, Egypt
                </strong>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        mode: {
            type: String,
            required: true
        }
    }
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base

.details
    padding-top: var(--line-base)
    padding-bottom: calc(var(--line-base) * 1.5)

    +media('>=small')
        display: flex
        padding-top: var(--section-padding)
        padding-bottom: var(--section-padding)

.column
    display: flex
    flex-direction: column
    gap: var(--line-base)

    p
        margin: 0

.link
    display: block
    font-weight: 600
</style>
